/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Sandy_Snake_GulpInputs */

const en_thin_sandy_snake_gulp = /** @type {(inputs: Thin_Sandy_Snake_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the type of import you want to create. Supported types are user and access rights import.`)
};

const de_thin_sandy_snake_gulp = /** @type {(inputs: Thin_Sandy_Snake_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie den Typ des Imports, den Sie erstellen möchten. Unterstützt wird der Import von Benutzern und Zugriffsrechten.`)
};

/**
* | output |
* | --- |
* | "Select the type of import you want to create. Supported types are user and access rights import." |
*
* @param {Thin_Sandy_Snake_GulpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_sandy_snake_gulp = /** @type {((inputs?: Thin_Sandy_Snake_GulpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Sandy_Snake_GulpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_sandy_snake_gulp(inputs)
	return de_thin_sandy_snake_gulp(inputs)
});